import { DataBean } from "../DataBean";

export class ConceptByProcessTypeSelect extends DataBean {



    public async getAccountantConceptListForProject(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getAccountantConceptListForProject_Number", [id]);
    }

}